import { Badge, Button, Card, Container, Group, Text, AppShell, Box, Space } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import RefreshQueryButton from "@/components/refresh-query-button";
import ColaboradoresAdminTable, {
  ModalFilterColaboradores,
  FiltroColaborador,
  QUERY_KEY as COLABORADORES_QUERY_KEY
} from "@/modules/licenciadas/components/colaboradores-admin-table";
import LicenciadasTable, {
  ModalFilterLicenciadas,
  FiltroLicenciada,
  QUERY_KEY
} from "@/modules/licenciadas/components/licenciadas-table";

const campoLabelsLicenciada: Record<string, string> = {
  razaoSocial: "Razão Social",
  cnpj: "CNPJ",
  responsavel: "Responsável",
  cidade: "Cidade",
  uf: "UF"
};

const campoLabelsColaborador: Record<string, string> = {
  nome: "Nome",
  email: "E-mail",
  role: "Perfil"
};

const REFRESH_ALL_LICENCIADAS_KEY = [QUERY_KEY];
const REFRESH_ALL_COLABORADORES_KEY = [COLABORADORES_QUERY_KEY];

const emptyFilterLicenciada: FiltroLicenciada = {
  search: "",
  campo: ""
};

const emptyFilterColaborador: FiltroColaborador = {
  search: "",
  campo: ""
};

const LicenciadaListaPage = () => {
  const navigate = useNavigate();
  const [filterLicenciada, setFilterLicenciada] = useState<FiltroLicenciada>(emptyFilterLicenciada);
  const [filterColaborador, setFilterColaborador] = useState<FiltroColaborador>(emptyFilterColaborador);

  const handleNovaLicenciada = useCallback(() => {
    navigate("/licenciadas/inclusao");
  }, [navigate]);

  return (
    <AppShell padding="md">
      <Box h="100vh" style={{ overflow: "auto" }}>
        <Container fluid py="xl" px="xl">
          <Card
            withBorder
            shadow="md"
            styles={{
              section: {
                overflow: "auto"
              }
            }}
          >
            <Card.Section inheritPadding py="md" withBorder>
              <Group justify="space-between">
                <Text fw={500} fz="lg">
                  Listagem de Licenciadas
                </Text>
                <Button leftSection={<IconPlus size="1rem" />} onClick={handleNovaLicenciada}>
                  Nova Licenciada
                </Button>
              </Group>
            </Card.Section>
            <Card.Section inheritPadding py="md" withBorder>
              <Group justify="space-between">
                <Group align="center">
                  <ModalFilterLicenciadas setFilter={setFilterLicenciada} />
                  {filterLicenciada.search && filterLicenciada.campo && (
                    <Badge variant="light" size="sm">
                      {campoLabelsLicenciada[filterLicenciada.campo] || filterLicenciada.campo}:
                      {filterLicenciada.search}
                    </Badge>
                  )}
                </Group>
                <RefreshQueryButton queryKey={REFRESH_ALL_LICENCIADAS_KEY} />
              </Group>
            </Card.Section>
            <LicenciadasTable filter={filterLicenciada} />
          </Card>

          <Space h="xl" />

          <Card
            withBorder
            shadow="md"
            styles={{
              section: {
                overflow: "auto"
              }
            }}
          >
            <Card.Section inheritPadding py="md" withBorder>
              <Group justify="space-between">
                <Text fw={500} fz="lg">
                  Colaboradores com Acesso às Licenciadas
                </Text>
              </Group>
            </Card.Section>
            <Card.Section inheritPadding py="md" withBorder>
              <Group justify="space-between">
                <Group align="center">
                  <ModalFilterColaboradores setFilter={setFilterColaborador} />
                  {filterColaborador.search && filterColaborador.campo && (
                    <Badge variant="light" size="sm">
                      {campoLabelsColaborador[filterColaborador.campo] || filterColaborador.campo}:
                      {filterColaborador.search}
                    </Badge>
                  )}
                </Group>
                <RefreshQueryButton queryKey={REFRESH_ALL_COLABORADORES_KEY} />
              </Group>
            </Card.Section>
            <ColaboradoresAdminTable filter={filterColaborador} />
          </Card>
        </Container>
      </Box>
    </AppShell>
  );
};

export default LicenciadaListaPage;
